export const Font = {
	largeTitle: 'Font-large-title',
	title1: 'Font-title1',
	title2: 'Font-title2',
	title3: 'Font-title3',
	headline: 'Font-headline',
	body: 'Font-body',
	callout: 'Font-callout',
	subHeadline: 'Font-subheadline',
	footnote: 'Font-footnote',
	caption1: 'Font-caption1',
	caption2: 'Font-caption2',
	largeTitleStrong: 'Font-large-title-strong',
	title1Strong: 'Font-title1-strong',
	title2Strong: 'Font-title2-strong',
	title3Strong: 'Font-title3-strong',
	headlineStrong: 'Font-headline-strong',
	bodyStrong: 'Font-body-strong',
	calloutStrong: 'Font-callout-strong',
	subHeadlineStrong: 'Font-subheadline-strong',
	footnoteStrong: 'Font-footnote-strong',
	caption1Strong: 'Font-caption1-strong',
	caption2Strong: 'Font-caption2-strong',
};

export const Color = {
	bluePrimary: 'Color-blue-primary',
	darkblue: 'Color-darkblue',
	bgPrimary: 'Color-bg-primary',
	bgSecondary: 'Color-bg-secondary',
	bgTertiary: 'Color-bg-tertiary',
	labelPrimary: 'Color-label-primary',
	labelSecondary: 'Color-label-secondary',
	labelTertiary: 'Color-label-tertiary',
	separatorNonOpaque: 'Color-separator-nonOpaque',
	separatorOpaque: 'Color-separator-opaque',
	fillPrimary: 'Color-fill-primary',
	red: 'Color-red',
	orange: 'Color-orange',
	yellow: 'Color-yellow',
	green: 'Color-green',
	green2: 'Color-green2',
	teal: 'Color-teal',
	blue: 'Color-blue',
	indigo: 'Color-indigo',
	purple: 'Color-purple',
	pink: 'Color-pink',
	grey0: 'Color-grey0',
	grey1: 'Color-grey1',
	grey2: 'Color-grey2',
	grey3: 'Color-grey3',
	grey4: 'Color-grey4',
	grey5: 'Color-grey5',
	grey6: 'Color-grey6',
	grey7: 'Color-grey7',
	white: 'Color-white',
	black: 'Color-black',
};

export const Margin = {
	Small: 'Margin-S',
	Medium: 'Margin-M',
	Large: 'Margin-L',
	HSmall: 'Margin-H-S',
	HMedium: 'Margin-H-M',
	HLarge: 'Margin-H-L',
	VSmall: 'Margin-V-S',
	VMedium: 'Margin-V-M',
	VLarge: 'Margin-V-L',
	TopSmall: 'Margin-T-S',
	TopMedium: 'Margin-T-M',
	TopLarge: 'Margin-T-L',
};

export const Gap = {
	Small: 'Gap-S',
	Medium: 'Gap-M',
	Large: 'Gap-L',
};
